import { useEffect, useState } from 'react'
import { Button, Col, Container, Form, Row, Spinner } from 'react-bootstrap'
import { useSelector } from 'react-redux'
import { useHistory } from 'react-router-dom'

import environment from '../../../environment'
import calcWeight from '../../../helpers/CalculationFunction'
import returnIcon from '../../../imgs/next.png'
import amazonImg from '../../../imgs/Shops/Amazon.png'
import asosImg from '../../../imgs/Shops/ASOS.png'
import bathbodyworksImg from '../../../imgs/Shops/Bath-Body-Works.jpg'
import cartersImg from '../../../imgs/Shops/Carters.png'
import gapImg from '../../../imgs/Shops/Gap.png'
import hmImg from '../../../imgs/Shops/H&M_small.png'
import mangoImg from '../../../imgs/Shops/Mango.png'
import nextImg from '../../../imgs/Shops/Next.png'
import primarkImg from '../../../imgs/Shops/Primark.png'
import pbImg from '../../../imgs/Shops/Pull&Bear.png'
import rhodeImg from '../../../imgs/Shops/Rhode.png'
import sephoraImg from '../../../imgs/Shops/Sephora.png'
import sportsDirectImg from '../../../imgs/Shops/Sports-Direct.png'
import uniqloImg from '../../../imgs/Shops/Uniqlo.png'
import walmartImg from '../../../imgs/Shops/Walmart.jpg'
// icons
import zaraImg from '../../../imgs/Shops/Zara.png'
import { createPackage, deletePackage, updatePackage } from '../../../services/packages'
import { listUsers } from '../../../services/users'
import { getAndIncreaseXLT } from '../../../services/xltNumberController'
import OfficeCountryNavBar from '../OfficeCountryNavBar/OfficeCountryNavBar'
import PackageContents from '../PackageContents'
import Sticker from '../Sticker/Sticker'
import { DraftPackagesTable } from './DraftPackagesTableOffice'

const BFM_UNIT = '559458872'

const initialCostumerState = {
  id: '',
  email: '',
  name: '',
  family_name: '',
  phone: '',
}

const initialPackageState = {
  costumer_firstName: '',
  costumer_LastName: '',
  costumer_Email: '',
  brand: '',
  trackingNumberInTurkey: '',
  width: 0,
  height: 0,
  length: 0,
  weight: 0,
  unit: '',
  dateArrived: new Date().toISOString().split('T')[0],
  acceptedBy: '',
  isPaid: false,
  costumer: '',
  isShipped: false,
  price: 0,
  isForUnite: false,
  shippingAdress_adress: '',
  shippingAdress_city: '',
  shippingAdress_postalCode: '',
  shippingAdress_apartmentNumber: '',
  shippingMethod: 'doorToDoor',
  contents: [],
  shippingPaid: 0,
  isDraft: false,
  isBFM: false,
  BFMId: null,
  batchName: '',
  isFlammable: false,
}

//TODO: the names of the imgs should be like in this lists
const usBrands = [
  '6pm',
  'A1supplements',
  'Adidas',
  'Advance Auto Parts',
  'Aldo Shoes',
  'All Beauty',
  'All Modern',
  'Amazon',
  'Ami Paris',
  'Anastasia',
  'Anastasia Beverly Hills',
  'Anthropologie',
  'Apple',
  'Arket',
  'Armani Exchange',
  'Auto Hausa',
  'Auto Zone',
  'Avon',
  'B & H Photo Video',
  'Babesta',
  'Banana Republic',
  'Barnes & Noble',
  'Bath & Body Works',
  'Bee Magic',
  'Benetton',
  'Bershka',
  'Billabong',
  'Bloomingdales',
  'Bobbi Brown Cosmetics',
  'Brooks Brothers',
  'Buy Auto Parts',
  'Buy Me Beauty',
  'Calvin Klein',
  'Camp',
  'Camper',
  'Carters',
  'Chanel',
  'Columbia',
  'Cos Bar',
  'Cover Girl',
  'Crate & Barrel',
  'Dell',
  'Dior',
  'Disney',
  'Dsw',
  'Dwr',
  'Ebay',
  'Electronic Express',
  'Eversio Wellness',
  'Evitamins',
  'Fawn & Forest',
  'Forever21',
  'Freepeople',
  'Gap',
  'Gapfactory',
  'Glossier',
  'Gucci',
  'H&M',
  'Halloween Costumes',
  'Honest',
  'Hotter',
  'Hsn',
  'Huda Beauty',
  'Hugo Boss',
  'J&p Cycles',
  "Joe's New Balance",
  'Joma-sport',
  'Kate Spade',
  'Kohls',
  'Lego',
  'Lenovo',
  'Lucky Brand',
  'Lush',
  'Mac',
  'Madewel',
  'Mango',
  'Mary Frances',
  'Massimo Dutti',
  'Michael Kors',
  'Mikasa',
  'Muji',
  'Nautica',
  'Newegg',
  'Nike',
  'Nine West',
  'Nordstrom',
  'Nyx Cosmetics',
  'Obag',
  'Oldnavy',
  'Organic Muscle',
  'Original4u',
  'Oysho',
  'Pandora',
  'Parts Geek',
  'Party City',
  'Pet',
  'Pier1',
  'Play Mobi',
  'Pottery Barnkids',
  'Prosource',
  'Pull&Bear',
  'Puma',
  'Qvc',
  'Ralph Lauren',
  'Rhode',
  'Rituals',
  'Rock Port',
  'Roxy',
  'Rugs Usa',
  'Sally Beauty',
  'Sephora',
  'Skechers',
  'Spirit Halloween',
  'Sport Direct',
  'Stanley',
  'Stories',
  'Stradivarius',
  "The Children's Place",
  'Timberland',
  'Timetospa',
  'Tommy Hilfiger',
  'Total Beauty Exp',
  'Tryarmra',
  'Ugg',
  'Ulta',
  'Uniqlo',
  'Victoriassecret',
  'Vineyard Vines',
  'Vita Cost',
  'Vitamin Shoppe',
  'Walgreens',
  'Walmart',
  'West Elm',
  'Williams Sonoma',
  'World Wide Stereo',
  'Yeti',
  'Yoox',
  'Zappos',
  'Zara',
  'Zara Home',
  'Other',
]

const greeceBrands = [
  '4f',
  '51015kids',
  'Adidas',
  'Allegro',
  'Aloyoga',
  'Amazon',
  'Amiparis',
  'Aptekagalen',
  'Asics',
  'Astratex',
  'Ataf',
  'Avon',
  'Babyland',
  'Baldinini',
  'Bartek',
  'Bath & Body Works',
  'Benetton',
  'Bershka',
  'Bigstar',
  'Bombela',
  'Calzedonia',
  'Camper',
  'C-and-a',
  'Carters',
  'Casu',
  'Ccc',
  'Chicco',
  'Claires',
  'Cobi',
  'Coccodrillo',
  'Cocomoda',
  'Columbia',
  'Conrad',
  'Converse',
  'Cortefiel',
  'Cosmostore',
  'Crocs',
  'Decathlon',
  'Deichmann',
  'Desigual',
  'Dior',
  'Douglas',
  'Doz',
  'Drmaxdrogeria',
  'Duka',
  'Dyson',
  'Ebutik',
  'Ecco',
  'E-glamour',
  'Electro',
  'Empik',
  'Endo',
  'Erli',
  'Espritshop',
  'Etam',
  'Ezebra',
  'Fikolki',
  'Flyingtiger',
  'Furla',
  'Gaia',
  'Gant',
  'Gap',
  'Gatta',
  'Gerryweber',
  'Go Shico',
  'Greenpoint',
  'Guess',
  'H&M',
  'Hebe',
  'Home-you',
  'Housebrand',
  'Hugo Boss',
  'Inglot',
  'Intersport',
  'Intimissimi',
  'Intrend',
  'Jdsports',
  'Joma-sport',
  'Kenzo',
  'Kikocosmetics',
  'Kiks - Sport',
  'Kodano',
  'Lacoste',
  'Lavard',
  'Lentiamo',
  'Levis',
  'Lidl',
  'Limango',
  'Lindex',
  'Loccitane',
  'Lululemon',
  'Mac',
  'Mamyito',
  'Mango',
  'Mango Outlet',
  'Marksandspencer',
  'Massimo Dutti',
  'Mediamarkt',
  'Mohito',
  'Moodo',
  'Morele',
  'Myspringfield',
  'Neonail',
  'Nespresso',
  'New Balance',
  'Newyorker',
  'Nike',
  'Nordstrom',
  'Obag',
  'Ochnik',
  'Oysho',
  'Panamajack',
  'Pandora',
  'Pedrodelhierro',
  'Peek-cloppenburg',
  'Pepejeans',
  'Perfumesco',
  'Petit-bateau',
  'Play Mobil',
  'Prezentmarzen',
  'Primamoda',
  'Promod',
  'Pull&Bear',
  'Puma',
  'Reebok',
  'Reserved',
  'Rituals',
  'Rossmann',
  'Royal-shop',
  'Rylko',
  'Salomon',
  'Sephora',
  'Shopbop',
  'Skechers',
  'Smyk',
  'Soczewki365',
  'Solar',
  'Stradivarius',
  'Swarovski',
  'Swatch',
  'Tchibo',
  'The Body Shop',
  'The North Face',
  'Timberland',
  'Tommy Hilfiger',
  'Topsecret',
  'Toryburch',
  'Trendyopticians',
  'Ugg',
  'Underarmour',
  'Uniqlo',
  'Vans',
  'Venezia',
  'Verona',
  'Victoriassecret',
  'Villeroy-boch',
  'Visionexpress',
  'Vitkac',
  'Welovelenses',
  'Wittchen',
  'Wojas',
  'Womensecret',
  'Wrangler',
  'Xiaomi',
  'Yankeecandle',
  'Yego',
  'Yoox',
  'Yves-rocher',
  'Zakupy',
  'Zalando',
  'Zara',
  'Zarahome',
  'Ziaja',
  'Other',
]

const ukBrands = [
  'ASOS',
  'Zara UK',
  'H&M UK',
  'New Look',
  'Marks & Spencer',
  'Next',
  'River Island',
  'Primark',
  'Boohoo',
  'Missguided',
  'PrettyLittleThing',
  'AllSaints',
  'Reiss',
  'Ted Baker',
  'Superdry',
  'Oasis',
  'COS',
  'Mango',
  'Uniqlo',
  'Amazon-UK',
  'Birkenstock UK',
  'Timberland UK',
  'JD Sports',
  'Sports-Direct',
  'Nike UK',
  'Under Armour UK',
  'Decathlon UK',
  'Adidas UK',
  'Sephora UK',
  'Cult Beauty',
  'Lush UK',
  'Konges Sløjd',
  'Other',
]

export default function AddNewPackagePage() {
  const { loggedUser } = useSelector(state => state.user)
  const history = useHistory()

  const [costumerState, setCostumerState] = useState(initialCostumerState)
  const [packageState, setPackageState] = useState(initialPackageState)
  const [isLoading, setIsLoading] = useState(false)
  const [draftPackages, setDraftPackages] = useState(null)
  const [isSent, setIsSent] = useState(false)
  const [draftLoader, setdraftLoader] = useState(false)
  const [isShowStickerCmp, setisShowStickerCmp] = useState(false)
  const [dataForStickerCmp, setdataForStickerCmp] = useState({})
  const [withoutPrice, setWithoutPrice] = useState(true)
  const [tfPackage, setTfPackage] = useState(false)
  const [warehouse, setWarehouse] = useState('')
  const [isOtherBrand, setIsOtherBrand] = useState(false)

  const [heightInch, setheightInch] = useState(Math.floor((packageState.height / 2.54) * 100) / 100)
  const [widthInch, setwidthInch] = useState(Math.floor((packageState.width / 2.54) * 100) / 100)
  const [lengthInch, setlengthInch] = useState(Math.floor((packageState.length / 2.54) * 100) / 100)
  const [weightPound, setweightPound] = useState(Math.floor(packageState.weight * 0.4535923 * 100) / 100)

  useEffect(() => {
    if (window.location.href.includes('office')) {
      document.getElementById('enable-toolbar').style.display = 'none'
    }
    // setWarehouse("USA")
    setWarehouse(loggedUser.UserAttributes['custom:warehouse'])
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  const setTurkeyTrackingNumber = value => {
    if (value.length >= 15) {
      if (packageState.brand === 'Pierre-Cardin') {
        setPackageState({
          ...packageState,
          trackingNumberInTurkey: value.substring(0, value.length - 6),
        })
        // console.log(value.substring(0, value.length - 6));
        return
      }
    }

    if (value.length >= 22) {
      if (
        packageState.brand === 'Zara' ||
        packageState.brand === 'Stradivarius' ||
        packageState.brand === 'Pull&Bear' ||
        packageState.brand === 'Oysho' ||
        packageState.brand === 'Massimo-Dutti' ||
        packageState.brand === 'Bershka'
      ) {
        setPackageState({
          ...packageState,
          trackingNumberInTurkey: value.substring(5, value.length - 6),
        })
        // console.log("1st if!", value.substring(4, value.length - 6));
        return
      }
    }

    setPackageState({
      ...packageState,
      trackingNumberInTurkey: value,
    })
  }

  const cleanState = () => {
    setCostumerState(initialCostumerState)
    setPackageState(initialPackageState)
    setIsLoading(false)
    setDraftPackages(null)
    setIsSent(false)
    setdraftLoader(false)
    setisShowStickerCmp(false)
    setdataForStickerCmp({})
    setTfPackage(false)
    setIsOtherBrand(false)
    window.scrollTo(0, 0)
  }

  const onAddContentClick = content => {
    setPackageState({
      ...packageState,
      contents: [...packageState.contents, content],
    })
  }

  const onRemoveContentClick = index => {
    setPackageState({
      ...packageState,
      contents: packageState.contents.filter((v, i) => i !== index),
    })
  }

  // const createAutoUnitReq = async oldPackageId => {
  //   // add isSplittedAutoReq for no charge + trackingNumberInTurkey + brand
  //   const data = {
  //     unit: costumerState.phone.slice(5),
  //     costumer: costumerState.id,
  //     costumer_name: costumerState.name,
  //     costumer_lastName: costumerState.family_name,
  //     costumer_phone: costumerState.phone,
  //     costumer_email: costumerState.email,
  //     warehouse: loggedUser.UserAttributes['custom:warehouse'],
  //     isSplittedAutoReq: true,
  //   }

  //   //create unite request
  //   const uniteResult = await createUnitePackage(data)
  //   const unitedObjId = uniteResult.data.response

  //   //update other package
  //   const params = {
  //     packageId: oldPackageId,
  //     updateParam: {
  //       uniteID: unitedObjId,
  //       isForUnite: true,
  //     },
  //   }
  //   dispatch(updatePackageAction(params))
  //   return unitedObjId
  // }

  const submitStateFormToDB = async () => {
    if (isLoading) return
    setIsLoading(true)

    // draft packages check
    const draftPackageSameTrackingNumber = draftPackages?.find(draftPackage => {
      return draftPackage.trackingNumberInTurkey === packageState.trackingNumberInTurkey
    })
    if (draftPackageSameTrackingNumber) {
      const confirmMsg = "The tracking number you've entered is already exists in splitted packages.\nAre you sure you want to continue?"
      const isConfirm = window.confirm(confirmMsg)
      if (!isConfirm) return
    }

    // check for same trackingNumberInTurkey for splitted packages
    // let unitedObjId
    // try {
    //   //check if there are more than 1 package with this turkey track num. 0 => catch error.
    //   let packagesByTurkeyNumResArr = await getPackageByTrackingNumberInTurkey(packageState.trackingNumberInTurkey)

    //   if (packagesByTurkeyNumResArr.length == 1) {
    //     packagesByTurkeyNumResArr = packagesByTurkeyNumResArr[0]

    //     // check if existing splitted package not paid already & same costumer
    //     if (!packagesByTurkeyNumResArr.isPaid && packagesByTurkeyNumResArr.costumer == packageState.costumer) {
    //       //check if the packages are same type
    //       if (packageState.isFlammable === packagesByTurkeyNumResArr.isFlammable) {
    //         unitedObjId = await createAutoUnitReq(packagesByTurkeyNumResArr.id)
    //       }
    //     }
    //   } else {
    //     //there are more than 1 package. check if they are belong to same costumer.
    //     const sameCostumerArr = packagesByTurkeyNumResArr.filter((p) => !p.isPaid && p.costumer == packageState.costumer)
    //     if (sameCostumerArr.length > 0) {
    //       //check if there is a unit req and add the new package.
    //       //if there isnt a unit req, check which one of the packages can be united with the new package.
    //       const flammableArr = sameCostumerArr.filter((p) => p.isFlammable)
    //       // console.log('submitStateFormToDB - flammableArr:', flammableArr)
    //       const notFlammableArr = sameCostumerArr.filter((p) => !p.isFlammable)
    //       // console.log('submitStateFormToDB - notFlammableArr:', notFlammableArr)

    //       // console.log("packageState.isFlammable", packageState.isFlammable);
    //       if (packageState.isFlammable) {
    //         if (flammableArr[0]?.uniteID) {
    //           // console.log("flammable yes uniteId");
    //           unitedObjId = flammableArr[0].uniteID
    //         } else {
    //           // console.log("flammable no uniteId");
    //           unitedObjId = await createAutoUnitReq(flammableArr[0].id)
    //         }
    //       } else {
    //         if (notFlammableArr[0]?.uniteID) {
    //           // console.log("not flammable yes uniteId");
    //           unitedObjId = notFlammableArr[0].uniteID
    //         } else {
    //           // console.log("not flammable no uniteId");
    //           unitedObjId = await createAutoUnitReq(notFlammableArr[0].id)
    //         }
    //       }
    //     }
    //   }
    // } catch (error) {
    //   console.log('submitStateFormToDB - error:', error)
    // }

    try {
      const isBFM = packageState.unit === BFM_UNIT
      let xlt = packageState.trackingNumberToIsrael

      // check if its draft package & prevent double sending
      if (!packageState.id && !isSent) {
        setIsSent(true)

        xlt = await getAndIncreaseXLT()

        const newPackageData = {
          ...packageState,
          unit: costumerState.phone.slice(5),
          isBFM,
          trackingNumberToIsrael: xlt,
          warehouse: warehouse,
          readyAt: packageState.isDraft ? `draft-${new Date().toISOString().split('T')[0]}` : new Date().toISOString().split('T')[0],
        }
        // console.log("submitStateFormToDB - newPackageData:", newPackageData)

        //check if splitted packages and auto unite
        // if (unitedObjId) {
        //   newPackageData.uniteID = unitedObjId
        //   newPackageData.isForUnite = true
        // }

        //check if its a tax-free package
        if (tfPackage) newPackageData.taxFreeFeeUSD = _getTaxFreeFee()
        // check if weight is less than 0.1
        if (parseFloat(newPackageData.weight) < 0.1) newPackageData.weight = 0.1

        await createPackage(newPackageData)
      } else {
        await updatePackage(packageState.id, {
          ...packageState,
          isBFM,
          readyAt: packageState.isDraft ? null : new Date().toISOString().split('T')[0],
          sendEmail: true,
        })
      }

      if (!packageState.isDraft) {
        setdataForStickerCmp({
          unit: costumerState.phone.slice(5),
          trackingNumberToIsrael: xlt,
          name: costumerState.name + ' ' + costumerState.family_name,
          brand: packageState.brand,
          address: costumerState.adress + ' ' + costumerState.apartment + ' ' + costumerState.city + ' ' + costumerState.postalCode,
        })
        setisShowStickerCmp(true)
      } else {
        alert('Success')
        cleanState()
      }
    } catch (error) {
      console.log('🚀 - submitStateFormToDB - error', error)
      if (error.response) alert(`Error! ${error.response.data?.msg}`)
      else alert(`Error! ${error}`)
    }
    setIsLoading(false)
  }

  const handleAfterPrint = async () => {
    cleanState()
    window.scrollTo(0, 0)
  }

  const loadDraftPackages = async _userId => {
    setdraftLoader(true)

    // draft packages not in use for now
    // const draftPackagesResponse = await getPackages({
    //   key: {
    //     index_name: 'costumer-index',
    //     primary: 'costumer',
    //     query: {
    //       costumer: userId,
    //     },
    //   },
    //   attr: { costumer: userId, isDraft: true },
    // })

    // if (typeof draftPackagesResponse === 'object') {
    //   const draftPackagesWithQuantity = draftPackagesResponse.map((p) => {
    //     const quantity = p.contents.reduce((acc, content) => {
    //       acc += +content.quantity
    //       return acc
    //     }, 0)

    //     p.totalQuantity = quantity
    //     return p
    //   })

    //   setDraftPackages(draftPackagesWithQuantity)
    // }
    setdraftLoader(false)
  }

  const getFormError = () => {
    if (!packageState.costumer) {
      return 'please insert customer details'
    }

    if (!packageState.isDraft && (!packageState.width || !packageState.height || !packageState.length || !packageState.weight)) {
      return 'please insert package size'
    }

    if (!packageState.brand) {
      return 'please insert package brand'
    }

    if (!packageState.trackingNumberInTurkey) {
      return 'please insert package tracking number'
    }

    if (!packageState.contents?.length) {
      return 'please insert package contents'
    }

    // Add this check for Other brand validation
    if (isOtherBrand && (packageState.brand === 'Other' || packageState.brand.trim() === '')) {
      return 'please enter a brand name'
    }

    if (packageState.weight > 20 || (packageState.height * packageState.length * packageState.width) / 5000 >= 30) {
      return 'Weight too high!'
    }
  }

  const searchByPhone = async () => {
    try {
      if (packageState.unit === '') {
        alert('cannot be empty')
        throw new Error('failed')
      }

      const formattedPhoneNumber = `+9720${packageState.unit}`

      const data = await listUsers(`phone_number = \"${formattedPhoneNumber}\"`)

      const users = data.users
      // console.log("data Users ", data.Users[0]);
      if (users.length === 0) {
        alert('Could not find a match')
        throw new Error('no match')
      }
      if (users) {
        // console.log("searchByPhone - users:", users)
        const user = users[0].Attributes
        const user_id = user.find(field => field.Name === 'sub')
        const email = user.find(field => field.Name === 'email')
        const firstName = user.find(field => field.Name === 'name')
        const lastName = user.find(field => field.Name === 'family_name')
        const adress = user.find(field => field.Name === 'custom:adress')
        const aptNum = user.find(field => field.Name === 'custom:apartment').Value ?? ''
        const phoneNumber = user.find(field => field.Name === 'phone_number')
        const postalCode = user.find(field => field.Name === 'custom:postalcode')
        const city = user.find(field => field.Name === 'custom:city')

        const obj = {
          id: user_id.Value,
          email: email.Value,
          name: firstName.Value,
          family_name: lastName.Value,
          phone: phoneNumber.Value,
          postalCode: postalCode?.Value,
          apartment: aptNum,
          adress: adress.Value,
          city: city.Value,
        }
        // console.log("searchByPhone - obj:", obj)

        await loadDraftPackages(obj.id)

        setCostumerState(obj)
        setPackageState({
          ...packageState,
          dateArrived: new Date().toISOString().split('T')[0],
          acceptedBy: loggedUser.Username,
          costumer: obj.id,
          costumer_firstName: obj.name,
          costumer_LastName: obj.family_name,
          costumer_Email: obj.email,
          shippingAdress_adress: obj.adress,
          shippingAdress_city: obj.city,
          shippingAdress_postalCode: obj.postalCode,
          shippingAdress_apartmentNumber: obj.apartment,
        })
      } else {
        console.log('empty')
        const obj = {
          id: '',
          email: '',
          name: '',
          family_name: '',
          phone: '',
        }
        setCostumerState(obj)
      }
    } catch (error) {
      const obj = {
        id: '',
        email: '',
        name: '',
        family_name: '',
        phone: '',
      }
      setCostumerState(obj)
      console.log(error)
    }
  }

  const _getTaxFreeFee = () => {
    let fee = 0
    let weight = calcWeight(packageState.width, packageState.length, packageState.height, packageState.weight)

    if (weight <= 5) fee = 5
    else if (weight <= 10) fee = 7
    else if (weight <= 15) fee = 10
    else if (weight <= 20) fee = 15
    else if (weight > 20) fee = 15 + (weight - 20)

    return fee
  }

  const onClickDraftPackage = draftPackage => {
    setDraftPackages(null)
    setPackageState(prevState => ({
      ...prevState,
      id: draftPackage.id,
      trackingNumberInTurkey: draftPackage.trackingNumberInTurkey,
      trackingNumberToIsrael: draftPackage.trackingNumberToIsrael,
      brand: draftPackage.brand,
      price: draftPackage.price,
      isDraft: draftPackage.isDraft,
      contents: draftPackage.contents,
    }))
  }

  const onClickDeleteDraftPackage = async draftPackage => {
    const trackingNumberInTurkey = prompt(`Please type '${draftPackage.trackingNumberInTurkey}' to confirm`)

    if (!trackingNumberInTurkey) return

    if (trackingNumberInTurkey !== draftPackage.trackingNumberInTurkey) {
      alert('Confirmation failed')
      return
    }

    try {
      await deletePackage(draftPackage.id)
      await loadDraftPackages(costumerState.id)
      setPackageState(prevPackageState => ({
        ...prevPackageState,
        id: undefined,
      }))
    } catch (error) {
      console.log(error)
      alert(error.data.response.msg)
    }
  }

  // const onClickTitle = isDraft => {
  //   setPackageState(prevState => ({ ...prevState, isDraft }))
  // }

  function handleKeypress(e) {
    if (e.key === 'Enter') searchByPhone()
  }

  const onChangePackageWithoutPrice = () => {
    setWithoutPrice(prevState => !prevState)
    setPackageState(prevState => ({
      ...prevState,
      price: 0,
    }))
  }

  const twoDecimals = num => {
    return Math.floor(num * 100) / 100
  }

  const autoFillFields = () => {
    setPackageState(prevState => ({
      ...prevState,
      brand: warehouse == 'UK' ? 'ASOS' : 'Zara',
      trackingNumberInTurkey: '123456789012345', // Example tracking number
      width: 10,
      height: 10,
      length: 10,
      weight: 2,
      price: 50,
      contents: [
        {
          productCategory: 'Skirt',
          quantity: 1,
        },
        {
          productCategory: 'Home Textile',
          quantity: 2,
        },
      ],
    }))
  }

  return (
    <>
      {isShowStickerCmp ? (
        <Sticker data={dataForStickerCmp} handleAfterPrint={handleAfterPrint}></Sticker>
      ) : (
        <Container style={{ marginTop: '5%' }} className='.container-om'>
          {draftLoader && (
            <div style={{ textAlign: 'center' }}>
              <Spinner animation='border' variant='primary' />
            </div>
          )}
          {draftPackages?.length > 0 && (
            <>
              <Row>
                <Col>
                  <h4
                    style={{
                      color: '#fcde00',
                      textAlign: 'center',
                      fontWeight: 'bolder',
                      marginBottom: '1rem',
                    }}
                  >
                    Splitted Packages
                  </h4>
                </Col>
              </Row>
              <DraftPackagesTable
                packages={draftPackages}
                onClickPackage={onClickDraftPackage}
                onClickDeleteDraftPackage={onClickDeleteDraftPackage}
              />
            </>
          )}

          {loggedUser.permissions['Admin'] && (
            <div className='payment-return-cont' onClick={() => history.push('/personal-info/myPackages')}>
              <div>חזרה לחבילות שלי</div>
              <img src={returnIcon} className='payment-return-img' />
            </div>
          )}

          {loggedUser.permissions['Admin'] && <OfficeCountryNavBar warehouse={warehouse} setWarehouse={setWarehouse} anp={true} />}

          <Row>
            <Col className='officeFormAdd'>
              <Form.Control
                style={{ width: '20%' }}
                onKeyPress={handleKeypress}
                onChange={e => {
                  setPackageState({ ...packageState, unit: e.target.value })
                }}
                placeholder='Unit'
              />
              <Button onClick={searchByPhone}>Search</Button>
              {loggedUser.permissions['Admin'] && environment.isDev && (
                <Button variant='info' onClick={autoFillFields} style={{ marginLeft: '10px' }}>
                  Auto-Fill Fields
                </Button>
              )}
              <Button
                block
                variant='danger'
                onClick={() => {
                  setCostumerState(initialCostumerState)
                  setPackageState(initialPackageState)
                }}
              >
                Reset Costumer
              </Button>
            </Col>
          </Row>

          <Row>
            <Col>
              {/* <Row
                style={{
                  justifyContent: 'center',
                  padding: '20px 50px',
                }}
              >
                <h3
                  onClick={() => onClickTitle(false)}
                  className={`add-package-title ${!packageState.isDraft ? 'add-package-active-title' : ''}`}
                >
                  New Package
                </h3>

                <h3 className="add-package-title">|</h3>

                <h3
                  onClick={() => onClickTitle(true)}
                  className={`add-package-title ${packageState.isDraft ? 'add-package-active-title' : ''}`}
                >
                  Splitted Package
                </h3>
              </Row> */}
              <Form id='addPackageForm'>
                <Form.Group>
                  <div style={{ display: 'flex', flexWrap: 'wrap' }}>
                    <Form.Group controlId='exampleForm.ControlInput1'>
                      <Form.Label>Costumer Name</Form.Label>
                      <Form.Control disabled type='text' placeholder={costumerState.name + ' ' + costumerState.family_name} />
                    </Form.Group>

                    <Form.Group controlId='exampleForm.ControlInput1' style={{ flexGrow: '1' }}>
                      <Form.Label>Costumer ID</Form.Label>
                      <Form.Control disabled type='text' placeholder={packageState.costumer} />
                    </Form.Group>

                    <Form.Group controlId='exampleForm.ControlInput1'>
                      <Form.Label>Costumer Email</Form.Label>
                      <Form.Control disabled type='email' placeholder={costumerState.email} />
                    </Form.Group>

                    <Form.Group controlId='exampleForm.ControlInput1'>
                      <Form.Label>Address</Form.Label>
                      <Form.Control
                        disabled
                        type='text'
                        placeholder={packageState.shippingAdress_adress + ' ' + packageState.shippingAdress_apartmentNumber}
                      />
                    </Form.Group>

                    <Form.Group controlId='exampleForm.ControlInput1'>
                      <Form.Label>Unit</Form.Label>
                      <Form.Control disabled type='text' placeholder={packageState.unit} />
                    </Form.Group>

                    <Form.Group controlId='exampleForm.ControlInput1'>
                      <Form.Label>City</Form.Label>
                      <Form.Control disabled type='text' placeholder={packageState.shippingAdress_city} />
                    </Form.Group>
                    <Form.Group controlId='exampleForm.ControlInput1'>
                      <Form.Label>PostalCode</Form.Label>
                      <Form.Control disabled type='text' placeholder={packageState.shippingAdress_postalCode} />
                    </Form.Group>
                  </div>

                  <Form.Group controlId='exampleForm.ControlInput1'>
                    <Form.Label>Brand</Form.Label>
                    <div className='add-form-flex notranslate'>
                      <Form.Control
                        style={{ width: '15%' }}
                        onChange={e => {
                          if (e.target.value === 'Other') {
                            setIsOtherBrand(true)
                            setPackageState({
                              ...packageState,
                              brand: 'Other',
                            })
                          } else {
                            setIsOtherBrand(false)
                            setPackageState({
                              ...packageState,
                              brand: e.target.value,
                            })
                          }
                        }}
                        name='brand'
                        as='select'
                        value={isOtherBrand ? 'Other' : packageState.brand}
                      >
                        <option></option>
                        {warehouse == 'GR' &&
                          greeceBrands.map(c => {
                            return <option key={c}>{c}</option>
                          })}
                        {warehouse == 'USA' &&
                          usBrands.map(c => {
                            return <option key={c}>{c}</option>
                          })}
                        {warehouse == 'UK' &&
                          ukBrands.map(c => {
                            return <option key={c}>{c}</option>
                          })}
                      </Form.Control>
                      {isOtherBrand && (
                        <Form.Control
                          style={{ width: '20%', marginLeft: '10px' }}
                          type='text'
                          placeholder='Enter Brand Name'
                          value={packageState.brand !== 'Other' ? packageState.brand : ''}
                          onChange={e => {
                            const customBrand = e.target.value.trim()
                            setPackageState({
                              ...packageState,
                              brand: customBrand === '' ? 'Other' : customBrand,
                            })
                          }}
                        />
                      )}
                      {warehouse == 'GR' && (
                        <div id='brands-images-cont'>
                          <img
                            onClick={() => {
                              setPackageState({ ...packageState, brand: 'Zara' })
                              setIsOtherBrand(false)
                            }}
                            src={zaraImg}
                          />
                          <img
                            onClick={() => {
                              setPackageState({ ...packageState, brand: 'H&M' })
                              setIsOtherBrand(false)
                            }}
                            src={hmImg}
                          />
                          <img
                            onClick={() => {
                              setPackageState({ ...packageState, brand: 'Mango' })
                              setIsOtherBrand(false)
                            }}
                            src={mangoImg}
                          />
                          <img
                            onClick={() => {
                              setPackageState({ ...packageState, brand: 'Pull&Bear' })
                              setIsOtherBrand(false)
                            }}
                            src={pbImg}
                          />
                        </div>
                      )}
                      {warehouse == 'USA' && (
                        <div id='brands-images-cont'>
                          <img
                            onClick={() => {
                              setPackageState({ ...packageState, brand: 'Gap' })
                              setIsOtherBrand(false)
                            }}
                            src={gapImg}
                          />
                          <img
                            onClick={() => {
                              setPackageState({ ...packageState, brand: 'Walmart' })
                              setIsOtherBrand(false)
                            }}
                            src={walmartImg}
                          />
                          <img
                            onClick={() => {
                              setPackageState({ ...packageState, brand: 'Sephora' })
                              setIsOtherBrand(false)
                            }}
                            src={sephoraImg}
                          />
                          <img
                            onClick={() => {
                              setPackageState({ ...packageState, brand: 'Amazon' })
                              setIsOtherBrand(false)
                            }}
                            src={amazonImg}
                          />
                          <img
                            onClick={() => {
                              setPackageState({ ...packageState, brand: 'Bath & Body Works' })
                              setIsOtherBrand(false)
                            }}
                            src={bathbodyworksImg}
                          />
                          <img
                            onClick={() => {
                              setPackageState({ ...packageState, brand: 'Carters' })
                              setIsOtherBrand(false)
                            }}
                            src={cartersImg}
                          />
                          <img
                            onClick={() => {
                              setPackageState({ ...packageState, brand: 'Rhode' })
                              setIsOtherBrand(false)
                            }}
                            src={rhodeImg}
                          />
                        </div>
                      )}
                      {warehouse == 'UK' && (
                        <div id='brands-images-cont'>
                          <img
                            onClick={() => {
                              setPackageState({ ...packageState, brand: 'ASOS' })
                              setIsOtherBrand(false)
                            }}
                            src={asosImg}
                          />
                          <img
                            onClick={() => {
                              setPackageState({ ...packageState, brand: 'Next' })
                              setIsOtherBrand(false)
                            }}
                            src={nextImg}
                          />
                          <img
                            onClick={() => {
                              setPackageState({ ...packageState, brand: 'Primark' })
                              setIsOtherBrand(false)
                            }}
                            src={primarkImg}
                          />
                          <img
                            onClick={() => {
                              setPackageState({ ...packageState, brand: 'Uniqlo' })
                              setIsOtherBrand(false)
                            }}
                            src={uniqloImg}
                          />
                          <img
                            onClick={() => {
                              setPackageState({ ...packageState, brand: 'Sports-Direct' })
                              setIsOtherBrand(false)
                            }}
                            src={sportsDirectImg}
                          />
                        </div>
                      )}
                    </div>
                  </Form.Group>

                  <Form.Group controlId='exampleForm.ControlInput1'>
                    <Form.Label>Tracking Number at arival to Office</Form.Label>
                    <Form.Control
                      onChange={e => {
                        setTurkeyTrackingNumber(e.target.value)
                        /* setPackageState({
                          ...packageState,
                          trackingNumberInTurkey: e.target.value,
                        }); */
                      }}
                      value={packageState.trackingNumberInTurkey}
                      name='trackingNumberInTurkey'
                      type='text'
                      placeholder=''
                    />
                  </Form.Group>

                  {warehouse == 'USA' && (
                    <Form.Group controlId='exampleForm.ControlInput1'>
                      <div style={{ display: 'flex', alignItems: 'center' }}>
                        <Form.Check checked={tfPackage} onChange={() => setTfPackage(!tfPackage)} />
                        <span>Delaware (Tax-Free) package</span>
                      </div>
                    </Form.Group>
                  )}

                  <Form.Group controlId='exampleForm.ControlInput1'>
                    <div style={{ display: 'flex', alignItems: 'center' }}>
                      <Form.Label>Price (local currency)</Form.Label>
                      <label
                        style={{
                          display: 'flex',
                          alignItems: 'center',
                          marginLeft: '20px',
                        }}
                      >
                        <Form.Check checked={withoutPrice} onChange={onChangePackageWithoutPrice} />
                        <span>The package has arrived without price</span>
                      </label>
                    </div>

                    <Form.Control
                      onChange={e => {
                        setPackageState({
                          ...packageState,
                          price: parseInt(e.target.value),
                        })
                      }}
                      type='text'
                      placeholder='price'
                      disabled={withoutPrice}
                      value={packageState.price}
                    />
                  </Form.Group>

                  <PackageContents
                    onContentAdded={onAddContentClick}
                    onContentsRemoved={onRemoveContentClick}
                    packageState={packageState}
                    setPackageState={setPackageState}
                    warehouse={warehouse}
                    id='package-content-cmp'
                  />
                </Form.Group>

                <Form.Group controlId='exampleForm.ControlInput1'>
                  <Form.Label>Box Size</Form.Label>
                  <div style={{ display: 'flex' }}>
                    <Form.Group controlId='exampleForm.ControlInput2'>
                      {warehouse !== 'USA' ? (
                        <>
                          <Form.Label>Height</Form.Label>
                          <Form.Control
                            onChange={e => {
                              const value = e.target.value
                              setPackageState({
                                ...packageState,
                                height: value === '' ? '' : !isNaN(parseFloat(value)) ? parseFloat(value) : 0,
                              })
                            }}
                            name='height'
                            type='number'
                            step='any'
                            value={packageState.height}
                            onWheel={e => e.target.blur()} // Prevent scroll from changing the value
                          />
                        </>
                      ) : (
                        <>
                          <Form.Label>Height (INCH)</Form.Label>
                          <Form.Control
                            onChange={e => {
                              const value = e.target.value
                              setPackageState({
                                ...packageState,
                                height: value === '' ? '' : !isNaN(parseFloat(value)) ? twoDecimals(parseFloat(value) * 2.54) : 0,
                              })
                              setheightInch(value)
                            }}
                            name='height'
                            type='number'
                            step='any'
                            value={heightInch}
                            onWheel={e => e.target.blur()} // Prevent scroll from changing the value
                          />

                          <Form.Label>Height (CM)</Form.Label>
                          <Form.Control name='height' type='number' step='any' value={packageState.height} disabled />
                        </>
                      )}
                    </Form.Group>

                    <Form.Group controlId='exampleForm.ControlInput3'>
                      {warehouse !== 'USA' ? (
                        <>
                          <Form.Label>Width</Form.Label>
                          <Form.Control
                            onChange={e => {
                              const value = e.target.value
                              setPackageState({
                                ...packageState,
                                width: value === '' ? '' : !isNaN(parseFloat(value)) ? parseFloat(value) : 0,
                              })
                            }}
                            name='width'
                            type='number'
                            step='any'
                            value={packageState.width}
                            onWheel={e => e.target.blur()} // Prevent scroll from changing the value
                          />
                        </>
                      ) : (
                        <>
                          <Form.Label>Width (INCH)</Form.Label>
                          <Form.Control
                            onChange={e => {
                              const value = e.target.value
                              setPackageState({
                                ...packageState,
                                width: value === '' ? '' : !isNaN(parseFloat(value)) ? twoDecimals(parseFloat(value) * 2.54) : 0,
                              })
                              setwidthInch(value)
                            }}
                            name='width'
                            type='number'
                            step='any'
                            value={widthInch}
                            onWheel={e => e.target.blur()} // Prevent scroll from changing the value
                          />

                          <Form.Label>Width (CM)</Form.Label>
                          <Form.Control name='width' type='number' step='any' value={packageState.width} disabled />
                        </>
                      )}
                    </Form.Group>

                    <Form.Group controlId='exampleForm.ControlInput4'>
                      {warehouse !== 'USA' ? (
                        <>
                          <Form.Label>Length</Form.Label>
                          <Form.Control
                            onChange={e => {
                              const value = e.target.value
                              setPackageState({
                                ...packageState,
                                length: value === '' ? '' : !isNaN(parseFloat(value)) ? parseFloat(value) : 0,
                              })
                            }}
                            name='length'
                            type='number'
                            step='any'
                            value={packageState.length}
                            onWheel={e => e.target.blur()} // Prevent scroll from changing the value
                          />
                        </>
                      ) : (
                        <>
                          <Form.Label>Length (INCH)</Form.Label>
                          <Form.Control
                            onChange={e => {
                              const value = e.target.value
                              setPackageState({
                                ...packageState,
                                length: value === '' ? '' : !isNaN(parseFloat(value)) ? twoDecimals(parseFloat(value) * 2.54) : 0,
                              })
                              setlengthInch(value)
                            }}
                            name='length'
                            type='number'
                            step='any'
                            value={lengthInch}
                            onWheel={e => e.target.blur()} // Prevent scroll from changing the value
                          />

                          <Form.Label>Length (CM)</Form.Label>
                          <Form.Control name='length' type='number' step='any' value={packageState.length} disabled />
                        </>
                      )}
                    </Form.Group>

                    <Form.Group controlId='exampleForm.ControlInput5'>
                      {warehouse !== 'USA' ? (
                        <>
                          <Form.Label>Weight</Form.Label>
                          <Form.Control
                            onChange={e => {
                              const value = e.target.value
                              setPackageState({
                                ...packageState,
                                weight: value === '' ? '' : !isNaN(parseFloat(value)) ? parseFloat(value) : 0,
                              })
                            }}
                            name='weight'
                            type='number'
                            step='any'
                            value={packageState.weight}
                            onWheel={e => e.target.blur()} // Prevent scroll from changing the value
                          />
                        </>
                      ) : (
                        <>
                          <Form.Label>Weight (Pound)</Form.Label>
                          <Form.Control
                            onChange={e => {
                              const value = e.target.value
                              setPackageState({
                                ...packageState,
                                weight: value === '' ? '' : !isNaN(parseFloat(value)) ? twoDecimals(parseFloat(value) * 0.4535923) : 0,
                              })
                              setweightPound(value)
                            }}
                            name='weight'
                            type='number'
                            step='any'
                            value={weightPound}
                            onWheel={e => e.target.blur()} // Prevent scroll from changing the value
                          />

                          <Form.Label>Weight (KG)</Form.Label>
                          <Form.Control name='weight' type='number' step='any' value={packageState.weight} disabled />
                        </>
                      )}
                    </Form.Group>
                  </div>
                </Form.Group>
              </Form>
            </Col>
          </Row>

          <Row>
            <Col>
              <Button disabled={getFormError() || isLoading} block onClick={submitStateFormToDB}>
                {packageState.isDraft ? 'Save' : 'Create'}
              </Button>
              <span className='alert-danger'>{getFormError()}</span>
            </Col>
          </Row>
        </Container>
      )}
    </>
  )
}
